var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.$vlastMode && _vm.$userIsClient
    ? _c(
        "a",
        {
          staticClass: "helpLink",
          attrs: { href: _vm.link, target: "_blank", "aria-label": "help" },
          on: { click: _vm.trackHelpClick },
        },
        [_c("i", { staticClass: "fa fa-question" })]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }